export enum UserSource {
    DailyChatHero = 'daily-chat-hero',
    DailyChatEmail = 'daily-chat-email',
}
